(function($) {


  //Product Gallery
	if ($('.product-imageslide .swiper-slide').length > 1) {
      
    document.querySelectorAll('.gallery-top').forEach((item) => {
      
      const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, { 
        direction: item.dataset.direction, 
        slidesPerView: 6,
        spaceBetween: 10,
        freeMode: true, 
        //noSwiping: false,
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            slidesPerView: 4,
          },
          425: { 
            direction: 'horizontal',  
            slidesPerView: 5,
          },
          769: { 
            direction: item.dataset.direction,  
            slidesPerView: 5,
          },
        }
      });
      const sliderImages = new Swiper(item, { 
        direction: item.dataset.direction, 
        slidesPerView: 1, 
        //loop:false,
        spaceBetween: 0, 
        speed: 1000,
        //draggable: false, 
        mousewheel: true,
        //allowTouchMove: false,
        grabCursor: true,
        //watchOverflow: true,
        thumbs: {
          swiper: sliderThumbs
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        breakpoints: { 
          0: { 
            direction: 'horizontal',  
            mousewheel: false,
          },
          769: { 
            direction: item.dataset.direction,
          },
        }
      });

    })
       
    }
    
    //Product Accordion
    $('.product__accordion details').on('click', function(){
      $(this).parent().siblings('.product__accordion').find('details').removeAttr('open');
    });
    //Size guid
    $('.js-guid-ajax').magnificPopup({
      type: 'ajax',
      showCloseBtn:true,
      closeOnBgClick: true,
      closeBtnInside: true,
      callbacks: {
        parseAjax: function(mfpResponse) {
          //console.log('dddddd');
          mfpResponse.data = jQuery(mfpResponse.data).find('#sizelist');
        },
        ajaxContentAdded: function(response) {

        }
      },
    });
    //Product gallery popup
    $('.zoom-gallery').magnificPopup({
      type: 'image',
			fixedContentPos: false,
			fixedBgPos: true,
			overflowY: 'auto',
			removalDelay: 300, //delay removal by X to allow out-animation
			callbacks: {
			beforeOpen: function() {
				  // just a hack that adds mfp-anim class to markup 
				   this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
				   this.st.mainClass = 'mfp-zoom-in customer-image custom-arrow';
				}
			  },
			closeBtnInside: true,
			preloader: false,
			
			midClick: true,
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1] 
			},
      buildControls: function() {
        // re-appends controls inside the main container
        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
      }
      
    });
    //how-apply-btn
    $('.js-how-apply-btn').magnificPopup({
      type: 'inline',
      preloader: false
    });
    //Product sticky button
    $(window).on("scroll",function () {
      let bodyScroll = $(window).scrollTop(),
          navbar = $(".sticky-order-panel");

      if(bodyScroll > $('.buy_btn-form').offset().top+30){
        navbar.addClass("product_appear");
      }else{
        navbar.removeClass("product_appear");
      }
    });
    if($(window).width() < 768){
      setTimeout(function(){
        
        $('.product-fixed-submit .add-to-cart-button[value]').text('Pre-order')
     
      },1500)

    }
// Auto-select default variant for Game Changer product
(function() {
  // Check if we're on the Game Changer product page
  if (window.location.pathname.includes('/products/the-game-changer-lift-shape-bra')) {
    const defaultVariantId = '44048414376209'; // Nood 7, Size 1
    
    // Check if variant parameter is already in URL
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('variant')) {
      // Redirect to the same page with the variant parameter
      window.location.href = window.location.pathname + '?variant=' + defaultVariantId;
    }
  }
})();




  
  
})(jQuery); //jQuery

